import {
	Button,
	Dialog, DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	FormControlLabel,
	Switch,
	TextField
} from "@mui/material";
import {useEffect, useState} from "react";
import FunctionsData from "../functions/FunctionsData";
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import pricingMarkdownFile from './html_pricing.md'
import pricingMarkdownCommunityFile from './html_pricing_community.md'
import moment from "moment";

export default function Step02(props) {

	const [valid, setValid] = useState(false);
	const [clickCancel, setClickCancel] = useState(false);
	const [campaigns, setCampaigns] = useState([]);
	const [campaignsLoading, setCampaignsLoading] = useState(true);
	const [pricingMarkdown, setPricingMarkdown] = useState(true);
	const [pricingMarkdownCommunity, setPricingMarkdownCommunity] = useState(true);
	const [pricingIssue, setPricingIssue] = useState(false);

	useEffect(() => {

		FunctionsData.fetchDataGet(
			FunctionsData.getApiUrl('/api/register/campaigns/') + props.state.frmAddressPostcode,
			setCampaigns, campaignsLoading, setCampaignsLoading
		)

		fetch(pricingMarkdownFile)
			.then((r) => r.text())
			.then(text => {
				setPricingMarkdown(text);
			})

		fetch(pricingMarkdownCommunityFile)
			.then((r) => r.text())
			.then(text => {
				setPricingMarkdownCommunity(text);
			})

	}, [])

	useEffect(() => {

		let allCapacity = props.state.capacity;
		let d = allCapacity.filter(({selected}) => selected > 0);
		let filled=0;
		for(let r in allCapacity) {

			allCapacity[r].day_capacity_neuter = String(allCapacity[r].day_capacity_neuter).replace(/[^0-9]/g,'');
			allCapacity[r].day_capacity_spay = String(allCapacity[r].day_capacity_spay).replace(/[^0-9]/g,'');

			if(allCapacity[r].day_capacity_neuter ==='' && allCapacity[r].selected > 0) filled=1;
			if(allCapacity[r].day_capacity_spay ==='' && allCapacity[r].selected > 0) filled=1;
		}

		props.setState({...props.state, capacity:allCapacity});
		setValid(
			d.length > 0 && filled === 0
		)
	}, [props.state.capacity])

	if (campaignsLoading === true) return null;
	return (
		<div style={{marginTop: 40}}>
			<div style={{marginTop: 40}} className={"form-box"}>

				<h2 style={{marginBottom: 5}}>Select type of campaign you are able to participate in:</h2>
				<h5 style={{marginBottom: 20}}>Surgery Requirements</h5>

				<ShowAnimalTypeSelect {...props} />

				{
					(valid === true) ?
						<ShowCampaignsSelect {...props} campaigns={campaigns}
						                     pricingMarkdown={pricingMarkdown}
						                     pricingMarkdownCommunity={pricingMarkdownCommunity}
						                     pricingIssue={pricingIssue}
						                     setPricingIssue={setPricingIssue}/>
						: undefined
				}

				<div>
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={"contained"}
					        onClick={() => props.setStep(props.step + 1)}
					        disabled={!valid}
					>
						{(props.state.campaigns.length !== 0) ? "Continue" : "Continue as expression of interest"}
					</Button>
					{
						(pricingIssue === true || 1===1) ?
							<Button color="primary" sx={{p: '15px', marginLeft: 1}} variant={"contained"}
							        onClick={() => {
								        setClickCancel(true);
							        }}
							>
								Cancel registration
							</Button>
							: undefined

					}
					{
						(clickCancel === true) ?
							<CancelDialog clickCancel={clickCancel} setClickCancel={setClickCancel}  />
							: undefined
					}
					<Button color="primary" sx={{p: '15px', marginLeft: 0}} aria-label="directions"
					        variant={""}
					        onClick={() => props.setStep(props.step - 1)}>
						Back
					</Button>
				</div>

			</div>
		</div>
	)
}

const CancelDialog = (props) => {
	return (
		<Dialog
			open={props.clickCancel}
			onClose={() => props.setClickCancel(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					We are sorry to see you go.  Your registration will not be completed and you will return to the start.If you would like to discuss the pricing structure please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}>snipnchip@spca.nz</a>.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.setClickCancel(false)}>Cancel</Button>
				<Button onClick={() => window.location.href = '/'} autoFocus>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	)
}

const ShowCampaignsSelect = (props) => {

	const [campaignTypes,setCampaignTypes] = useState([]);
	const [campaignsFiltered,setCampaignsFiltered] = useState([]);

	useEffect(() => {
		let d = [];
		props.state.capacity.forEach((x) => {
			if(x.selected > 0) {
				d.push(String(x.key).toLowerCase());
			}
		})

		let newCamp = [];
		props.campaigns.forEach((c) => {
			newCamp.push(c);
		})

		setCampaignTypes(d);
		setCampaignsFiltered([...newCamp]);

	}, [props.state.capacity]);

	if (campaignsFiltered.length === 0) return (
		<>
			<h2 style={{marginBottom: 20}}>Current campaigns</h2>
			<p>
				Thank you for your interest in our Desexing programme. There are no campaigns currently running in your area, or planned within the next 6 weeks.
			</p>
			<p>We’d still love to hear from you though. Please continue as an expression of interest and we'll be in touch when there is a campaign in your area.</p>
		</>

	)

	return (
		<div>
			<h2 style={{marginBottom: 20}}>
				{
					(props.campaigns.length > 0) ?
						"From the list below, please select the current campaign/s you would like to take part in:"
						: "No current campaigns"
				}
			</h2>
			{
				campaignsFiltered.map((campaign) => {
					if(props.state.accepted_type === 'community' && campaign.campaign_target === 'public') return null;
					if(props.state.accepted_type === 'inspectors' && campaign.campaign_target === 'public') return null;
					if(props.state.accepted_type === 'public' && campaign.campaign_target !== 'public') return null;
					if(
						props.state.capacity.filter(({selected,slug}) => slug === 'feline' && selected > 0).length === 0 &&
						props.state.capacity.filter(({selected,slug}) => slug === 'canine' && selected > 0).length > 0 &&
						campaign.campaign_target === 'public'
					) return null;
					return (
						<ShowCampaign {...props} campaign={campaign}/>
					)
				})
			}
			<ShowCampaignsMessage {...props} />
		</div>
	)
}

const ShowCampaignsMessage = (props) => {
	const [clickCancel,setClickCancel] = useState(false);
	const LinkExit = (props) => {
		return (
			<>
				<a href={"#"} style={{color: 'red'}} onClick={(e) => {
					e.preventDefault();
					setClickCancel(true);
				}}>here</a>
				{
					(clickCancel === true) ?
						<CancelDialog clickCancel={clickCancel} setClickCancel={setClickCancel}  />
						: undefined
				}
			</>
		)
	}
	const PricingText = () => {
		if (props.pricingIssue === false) return null;
		return (
			<p style={{marginTop: 20, fontWeight: 'bold'}}>
				IMPORTANT:<br/>
				&nbsp;You indicated that you are not agreeing with the pricing arrangement for one or more campaigns.
				You can continue as expression of interest, or cancel your registration process <LinkExit {...props} />.
			</p>
		)
	};

	if(props.campaigns.length === 0) return (
		<div style={{margin: '20px 0'}}>
			<p>There are no campaigns currently running in your area.</p>
			<p>We’d still love to hear from you though. Please continue as an Expression of Interest and we’ll be in touch when there is a campaign in your area.</p>
		</div>
	)

	if ((props.campaigns.length !== 0 && props.state.campaigns.length === 0))
		return (
			<div style={{margin: '20px 0'}}>
				<p>
					Would you like to continue as an expression of interest only? SPCA will review your registration
					details but your clinic will <b>NOT</b> be signed up to a campaign.
				</p>
				<PricingText {...props} />
			</div>
		)

	return null;
}

const ShowCampaign = (props) => {

	const [active, setActive] = useState(false);
	const [openPricing, setOpenPricing] = useState(false);

	useEffect(() => {

		if (props.state.campaigns.filter(itm => String(itm) === String(props.campaign.id)).length > 0) {
			setActive(true)
		} else {
			setActive(false)
		}

	}, []);

	function fn() {
		let d = props.state.campaigns;
		let dTexts = props.state.campaignsTexts;
		let consent = props.state.campaignsConsent;
		if (active !== true) {
			d.push(props.campaign.id);
			dTexts.push(props.campaign.name);
			consent.push({
				id: props.campaign.id, consentDate: new Date()
			});
		} else {
			d = d.filter(itm => String(itm) !== String(props.campaign.id))
			dTexts = dTexts.filter(name => String(name) !== String(props.campaign.name))
			consent = consent.filter(({id}) => String(id) !== String(props.campaign.id))
		}
		d = [...new Set(d)];
		const eoi = (d.length > 0) ? 0 : 1;
		//console.log(d, consent, props.campaign)

		props.setState({...props.state, campaigns: [...d], campaignsConsent: [...consent], eoi: eoi, campaignsTexts:[...dTexts]});
		setActive(!active);
		setOpenPricing(false);
	}

	let startDate = moment(props.campaign.start_date).format('DD/MM/YYYY');
	let endDate = moment(props.campaign.end_date).format('DD/MM/YYYY');

	return (
		<div>
			<FormControlLabel control={<Switch checked={active} onChange={() => {
				if (active === false) {
					setOpenPricing(true);
				} else {
					fn();
				}
			}}/>} label={
				props.campaign.name +
				((props.campaign.campaign_target !== 'public') ? "" : " (" + startDate + " - " + endDate + ")") +
				((props.campaign.campaign_target !== 'public') ? " - Community" : " - Snip'n'Chip")
			}/>
			{
				(openPricing === true) ?
					<ShowPricing {...props} openPricing={openPricing} setOpenPricing={setOpenPricing} fn={fn} target={props.campaign.campaign_target}/>
					: undefined

			}
		</div>
	)
}

const ShowPricing = (props) => {
	return (
		<Dialog
			open={props.openPricing}
			onClose={() => props.setOpenPricing(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			scroll={"paper"}
		>
			<DialogTitle id="alert-dialog-title">
				{"Please agree to our pricing for this campaign"}
				<hr style={{margin: 0, width: '100%'}}/>
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					<div className={"markdown-pricing"}>
						<ReactMarkdown
							remarkPlugins={[[remarkGfm, {singleTilde: false}]]}>{(props.campaign.campaign_target !== 'public') ? props.pricingMarkdownCommunity : props.pricingMarkdown}
						</ReactMarkdown>
					</div>
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => {
					props.setPricingIssue(true);
					props.setOpenPricing(false);
				}}>Disagree</Button>
				<Button onClick={() => {
					props.fn();
				}} autoFocus>
					I have read and agree to the above
				</Button>
			</DialogActions>
		</Dialog>
	)
}

const ShowAnimalTypeSelect = (props) => {

	function updateValue(col, val, slug) {
		let d = props.state.capacity;
		for (let x in d) {
			if (d[x]['slug'] === slug) {
				d[x][col] = val;
			}
		}
		props.setState({...props.state, capacity: [...d]});
	}

	return (
		<div>
			{
				props.state.capacity.map((row, i) => {
					return (
						<ShowAnimalTypeSelectRow {...props} key={i} row={{...row}} updateValue={updateValue}/>
					)
				})
			}
		</div>
	)
}

const ShowAnimalTypeSelectRow = (props) => {

	return (
		<div style={{marginBottom: 20}}>
			<FormControlLabel control={<Switch checked={(props.row.selected > 0)}
			                                   onChange={(e) => props.updateValue('selected', (props.row.selected === 0) ? 1 : 0, props.row.slug)}/>}
			                  label={props.row.label}/>
			{
				(props.row.selected > 0) ?
					<div style={{display: 'flex', flex: '1 0 100%', width: '100%'}}>
						<div style={{flexGrow: 1, marginRight: 5}}>
							<TextField value={props.row.minimum_weight} focused
							           onChange={(e) => props.updateValue('minimum_weight', e.currentTarget.value, props.row.slug)}
							/>
							<p>Minimum weight</p>
						</div>

						<div style={{flexGrow: 1, marginRight: 5}}>
							<TextField value={props.row.minimum_age} focused
							           onChange={(e) => props.updateValue('minimum_age', e.currentTarget.value, props.row.slug)}
							/>
							<p>Minimum age</p>
						</div>

						<div style={{flexGrow: 1, marginRight: 5}}>
							<TextField value={props.row.day_capacity_spay} focused
							           error={(props.row.day_capacity_spay === '')}
							           onChange={(e) => props.updateValue('day_capacity_spay', e.currentTarget.value, props.row.slug)}
							/>
							<p>Capacity spay / day*</p>
						</div>

						<div style={{flexGrow: 1, marginRight: 5}}>
							<TextField value={props.row.day_capacity_neuter} focused
							           error={(props.row.day_capacity_neuter === '')}
							           onChange={(e) => props.updateValue('day_capacity_neuter', e.currentTarget.value, props.row.slug)}
							/>
							<p>Capacity neuter / day*</p>
						</div>

					</div>
					: undefined
			}
		</div>
	)
}
